import { DetailsItem } from '@calendly/booking-kit'
import { UserMultipleIcon } from '@calendly/ui/components/icons'
import PropTypes from 'prop-types'


export const Attendees = ({ items }) => items.length > 1 && (
  <DetailsItem as="div">
    <UserMultipleIcon size="large" spacingRight={8} />
    {items.join(', ')}
  </DetailsItem>
)

Attendees.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired
}
